import Vue from 'Vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    metaInfo: {
      title: '',
      keywords: '',
      description: ''
    }
  },
  mutations: {
    CHANGE_META_INFO (state, metaInfo) {
      console.log('metaInfo')
      state.metaInfo = metaInfo
    }
  },
  actions: {},
  modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js